import React from 'react';
import i18n from '@i18n';
import ArrowDownIcon from '@/icons/ArrowDownIcon';
import FakeCheckInput from '@/nikeone/components/FakeCheckInput';

class FilterSliderFake extends React.PureComponent {
    render() {
        return this.props.live ? (
            <div className="nikeone-filter-slider page-blur">
                <div className="nikeone-filter-item disabled">
                    <span>{i18n('nikeOne.dialogs.live.zobrazitPodla.casu')}</span>
                    <FakeCheckInput />
                </div>
                <div className="nikeone-filter-item disabled">
                    <span>{i18n('nikeOne.dialogs.live.zobrazitPodla.ibaStream')}</span>
                    <FakeCheckInput />
                </div>
            </div>
        ) : (
            <div className="nikeone-filter-slider page-blur">
                <div className="nikeone-filter-item disabled">
                    <span>{i18n('enum.calendar.anytime').toUpperCase()}</span>
                    <div className="arrow-down">
                        <ArrowDownIcon />
                    </div>
                </div>
                <div className="nikeone-filter-item disabled">
                    <span>{i18n('cms.countries.any')}</span>
                    <div className="arrow-down">
                        <ArrowDownIcon />
                    </div>
                </div>
            </div>
        );
    }
}

export default FilterSliderFake;
